import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import FireGray from 'src/assets/images/icons/custom-icons/FireGray';
import FireOrange from 'src/assets/images/icons/custom-icons/FireOrange';
import FireYellow from 'src/assets/images/icons/custom-icons/FireYellow';
import { REWARD_DAYS } from 'src/utils/streak-day-cell-flags.util';

dayjs.extend(timezone);

interface StreakStatusIconOptions {
  currentStreak?: number | null;
  streakStartDate?: string | null;
  bonusCycleDay?: number | null;
  timezone?: string | null;
  className?: string;
}

export function getIsStreakCompletedToday({
  currentStreak,
  streakStartDate,
  timezone: userTimezone,
}: StreakStatusIconOptions): boolean {
  if (!currentStreak || !streakStartDate) {
    return false;
  }

  const timezoneName = userTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return dayjs().tz(timezoneName).diff(dayjs.tz(streakStartDate, timezoneName).startOf('day'), 'day') < currentStreak;
}

export function getStreakStatusIcon({
  bonusCycleDay,
  className = 'h-full w-full',
  ...streakOptions
}: StreakStatusIconOptions) {
  if (!getIsStreakCompletedToday(streakOptions)) {
    return <FireGray className={className} />;
  }

  if (REWARD_DAYS.includes(bonusCycleDay || 0)) {
    return <FireYellow className={className} />;
  }

  return <FireOrange className={className} />;
}
